export enum SupplierStatus {
    INACTIVE,
    ACTIVE,
    PENDING,
    PROCESSING
}
